import React, { createContext, useCallback, useContext, useEffect, useState } from "react";

// Contexto de la aseguradora seleccionada en la sesión actual (código de
// aseguradora de la póliza elegida por el cliente — ver general.js,
// handleChangeRam). Existe para que componentes ajenos al flujo de pólizas
// (ej. Footer.js) puedan REACCIONAR cuando esa aseguradora cambia — login,
// selección de póliza, logout — en vez de leer sessionStorage una sola vez
// de forma imperativa y quedar desactualizados para siempre.

const CLAVE_SESSION_STORAGE = "codigoAseguradora";

const AseguradoraContext = createContext({
  codigoAseguradora: null,
  establecerCodigoAseguradora: () => {},
});

export function AseguradoraProvider({ children }) {
  const [codigoAseguradora, setCodigoAseguradora] = useState(null);

  // Se lee en un efecto (no como estado inicial) para garantizar que corre
  // DESPUÉS de que App.js limpie sessionStorage en su constructor — así el
  // valor inicial siempre refleja lo que realmente quedó en sessionStorage
  // tras esa limpieza, nunca un valor "fantasma" de la sesión anterior.
  useEffect(() => {
    const valorActual = sessionStorage.getItem(CLAVE_SESSION_STORAGE);
    if (valorActual) {
      setCodigoAseguradora(valorActual);
    }
  }, []);

  // Actualiza sessionStorage (compatibilidad con el resto de la app, que ya
  // lo lee directamente, ej. RedProveedores.js) Y el estado de React — es
  // ese segundo paso el que le faltaba al flujo actual, y es lo que permite
  // que cualquier consumidor de este contexto se re-renderice solo.
  const establecerCodigoAseguradora = useCallback((codigo) => {
    if (codigo) {
      sessionStorage.setItem(CLAVE_SESSION_STORAGE, codigo);
    } else {
      sessionStorage.removeItem(CLAVE_SESSION_STORAGE);
    }
    setCodigoAseguradora(codigo || null);
  }, []);

  return (
    <AseguradoraContext.Provider value={{ codigoAseguradora, establecerCodigoAseguradora }}>
      {children}
    </AseguradoraContext.Provider>
  );
}

export function useAseguradora() {
  return useContext(AseguradoraContext);
}

export default AseguradoraContext;
